import { format } from 'date-fns';
import { SocialType } from './share';

export const analytics = {
  gtag: {
    event: (action: string, params?: Record<string, string>) => {
      // @ts-expect-error gtag is added in html.head:
      const { gtag } = window;
      if (process.env.ENV === 'local') {
        console.log('gtag:local', action, params);
        return;
      }

      if (gtag) {
        console.log('gtag:', action, params);
        gtag('event', action, params);
      } else {
        console.log('%cgtag is undefined', 'color: red');
      }
    },
  },
};

export const onResultsClick = (date: Date) => {
  analytics.gtag.event(`לתוצאות`, {
    CUSTOM_PARAMETER: format(date, 'dd/MM/yyyy'), // 01/01/2000
  });
};

export const onGeneralShareChoice = (type: SocialType) => {
  const eventsMap = {
    facebook: `facebook`,
    whatsapp: `whatsapp`,
    x: `x`,
    'e-mail': `email`,
  };

  analytics.gtag.event(`שיתוף בעמוד הראשי`, {
    CUSTOM_PARAMETER: eventsMap[type],
  });
};

export const onResultsShareChoice = (type: SocialType) => {
  const eventsMap = {
    facebook: `facebook`,
    whatsapp: `whatsapp`,
    x: `x`,
    'e-mail': `email`,
  };

  analytics.gtag.event(`שיתוף בעמוד תוצאה`, {
    CUSTOM_PARAMETER: eventsMap[type],
  });
};

export const onMakoLogoClick = () => {
  analytics.gtag.event(`לאתר מאקו`);
};

export const onReSearchClick = () => {
  analytics.gtag.event(`חיפוש מחדש`);
};
